/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use } from 'fierry/react';

import Route from 'solis/route';
import { useArg } from 'solis/navigation';
import Galaxy from 'solis/application/galaxy';
import Time from 'solis/time';

import Hex from 'solis/type/hex';

import Args from 'solis/claude/action/args';

import CreateAnchor from 'solis/claude/action/descriptor/create.anchor';

import * as Placement from 'solis/claude/logic/board/placement';


// Resolves the attach nav args: the picked board hex is one the colony must cover;
// position iterates the legal footprints, snuggest fit first. An optional target colony
// narrows the docking hexes to its rim and anchors the placement to it — otherwise the
// anchor colony is derived from the footprint.
export default (board) =>
{
  const route = use(Route);
  const galaxy = use(Galaxy);
  const now = use(Time);

  const anchorColony = useArg(Args.AnchorColony);
  const target = useArg(Args.AnchorTarget);
  const anchorPosition = useArg(Args.AnchorPosition);

  const sourceColony = galaxy.getColony(route.getArg('colony'));

  const account = galaxy.getCurrentAccount();

  const targetColonyID = anchorColony ?? null;

  const targets = Placement.getPlacementTargets(board, sourceColony, targetColonyID);

  const base = { board, now, account, galaxy, sourceColony, targets, transforms: null, position: 0, rotation: 0, transform: null, placedHexes: null, conflict: false, targetColony: targetColonyID };

  // Clicks only count on the marked docking hexes — a hex further out can still admit
  // covering placements, but resolving those reads as noise instead of a pick.
  const transforms = target && targets.contains(new Hex(target)) ? Placement.getPlacementTransforms(board, sourceColony, new Hex(target), targetColonyID) : [];

  if (transforms.length === 0)
  {
    return { ...base, valid: false, issues: [ 'Pick a highlighted spot on the board' ] };
  }

  const position = (Number(anchorPosition) >= 0 && Number(anchorPosition) < transforms.length) ? Number(anchorPosition) : 0;

  const transform = transforms[position];
  const placedHexes = Placement.getPlacedHexes(sourceColony, transform);

  const targetColony = targetColonyID ?? Placement.getTargetColonyID(board, placedHexes);

  const result = { ...base, transforms, position, rotation: transform.rotation, transform, placedHexes, targetColony };

  return { ...result, ...CreateAnchor.validate(result) };
};
